export default "__VITE_ASSET__pnUqnG_t__"